import React, { useState } from "react";
import "./mainHero.scss";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { EffectFade, Navigation, Autoplay } from "swiper/modules";

// data
import mainHerodata from "../../../assets/data/mainHeroData";

const MainHero = () => {
  const [count, setCount] = useState(0);
  return (
    <section className="mainHero" id="home">
      <Swiper
        className="slideContainer"
        spaceBetween={30}
        effect={"fade"}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop={true}
        navigation={true}
        modules={[EffectFade, Navigation, Autoplay]}
        speed={3500}
        onSlideChange={() => setCount(count + 1)}
      >
        {mainHerodata.map((item, index) => {
          return (
            <SwiperSlide key={item.id} className="slide">
              <div className="slideImg">
                <img src={item.image} alt={item.title} />

                <div className="slideImgLayer"></div>
              </div>

              <div key={count} className="slideContent">
                <p className="slideContent__name">{item.name}</p>
                <h1>{item.title}</h1>
                <p>{item.subtitle}</p>

                <div className="mh__socials">
                  {item?.socials?.map((social, index) => {
                    return (
                      <a
                        key={index}
                        href={social.link}
                        target="_blank"
                        rel="noreferrer"
                        className="mh__social"
                        style={{
                          animation: `socialIconAnimation 3s ease forwards ${
                            index * 0.3
                          }s`,
                          transition: "all 1s ease",
                        }}
                      >
                        <i className={social.icon}></i>
                      </a>
                    );
                  })}
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>

      <div className="mainHero__bottom">
        <div className="mainHero__bottom__container"></div>
      </div>
    </section>
  );
};

export default MainHero;
